import { Navigate } from 'react-router-dom';
import { ADMIN, BRISTEC_ADMIN, MODERATOR, USER } from '../const/constants';
import { useAuth } from '../hooks/useAuth';

interface PrivateRouteProps {
	element: JSX.Element;
	roles?: string[];
}

export function PrivateRoute({
	element,
	roles = [USER, BRISTEC_ADMIN, MODERATOR, ADMIN],
}: PrivateRouteProps) {
	const auth = useAuth();

	return roles.includes(auth.getRole()) ? (
		<>{element}</>
	) : (
		<>
			<Navigate to="/login" />
		</>
	);
}

export function AdminRoute({
	element,
	roles = [USER, BRISTEC_ADMIN, MODERATOR, ADMIN],
}: PrivateRouteProps) {
	const auth = useAuth();

	return roles.includes(auth.getRole()) ? (
		<>{element}</>
	) : (
		<>
			<Navigate to="/" />
		</>
	);
}
